export default {
  "header": {
    "search": "Search"
  },
  "help": {
    "code": "It corresponds to the driver’s unique identification number which can be its identification number (ID), or any other code given by the Company.",
    "codeVehicle": "It corresponds to the equipment’s identification number which can be its license plate, or any other code given by the Company.",
    "codeSemiTrailer": "It corresponds to the ramp’s unique identification number which can be its license plate, or any other code given by the Company.",
    "codeGeo": "It corresponds to the geographical zone’s identification number.",
    "dataSource": "It corresponds to the driver’s codes which come from external sources of information: SAP, ERP’s, among others.",
    "dataSourceVehicle": "It corresponds to the equipment’s codes which come from external sources of information: SAP, ERP’s, among others.",
    "dataSourceSemiTrailer": "It corresponds to the ramp’s codes which come from external sources of information: SAP, ERP’s, among others.",
    "workingShiftGroupHelp": "It corresponds to the rotation shift group to which the person was assigned for at the time of the consult.",
    "state": {
      "title": "It represents the information source’s state of association.",
      "listDatasource": {
        "name": "-Associated to sources of information.",
        "text": ": driver with at least one source of information configured in the platform.",
        "textVehicle": ": equipment with at least one source of information configured in the platform.",
        "textSemiTrailer": ": ramp with at least one source of information configured in the platform."
      },
      "noListDatasource": {
        "name": "-No associations to sources of information.",
        "text": ": driver without any associated source of information.",
        "textVehicle": ": equipment without any associated source of information.",
        "textSemiTrailer": ": ramp without any associated source of information."
      }
    }
  },
  "expire": {
    "vehicules": {
      "title": "Equipment Association"
    },
    "semiTrailers": {
      "title": "Ramp Association"
    },
    "text": "Connection expired"
  },
  "title": {
    "driver": "Driver’s list",
    "vehicules": "Equipment list",
    "semiTrailers": "Ramp’s list",
    "homologation": "Unknown drivers",
    "homologationVehicle": "Unknown equipment",
    "homologationSemiTrailer": "Unknown ramps",
    "workingShiftGroup": "Shift groups"
  },
  "table": {
    "code": "Code",
    "name": "Name",
    "dataSource": "Codes in sources of information.",
    "state": "State",
    "setting": "Actions",
    "endTime": "There is no more information",
    "row": "Line",
    "workingShiftGroup": "Shift group"
  },
  "homologationDriver": {
    "AssociateTeam": "Equipment’s association",
    "createTeam": "Create equipment",
    "AssociateSemiTrailer": "Ramp association",
    "createSemiTrailer": "Create ramp",
    "downloadExcel": "Download Excel template",
    "importExcelFile": "Import Excel template",
    "downloadFileName": "homologationDriver",
    "table": {
      "source": "Information Source",
      "dataSource": "External information source’s name: SAP, ERP’s, among others.",
      "codeExterno": "Code of the driver who comes from the external source of information: SAP, ERP’s, among others.",
      "codeExternoVehicle": "Code of the equipment which comes from the external source of information code: SAP, ERP’s, among others.",
      "codeExternoSemiTrailer": "Code of the ramp which comes from the external source of information: SAP, ERP’s, among others.",
      "dataSourceAlias": "Information obtained through the external source of information about the driver.",
      "dataSourceVehicle": "Information obtained through the external source of information about the equipment.",
      "dataSourceSemiTrailer": "Information obtained through the external source of information about the ramp.",
      "code": "External code",
      "alias": "Driver’s information",
      "aliasVehicle": "Equipment’s information",
      "aliasSemiTrailer": "Ramp’s information",
      "codeAndName": "Existing driver to be assigned",
      "codeAndNameVehicle": "Existing equipment to be assigned",
      "codeAndNameSemiTrailer": "Existing ramp to be assigned",
      "selectDriver": "Please, choose a driver",
      "selectVehicle": "Please, choose an equipment",
      "selectSemiTrailer": "Please, choose a ramp"
    },
    "vehicules": "Equipments",
    "semiTrailers": "Ramps",
    "detail": "Detail",
    "code": "Code",
    "name": "Name",
    "text": "It corresponds to the driver’s unique identification number which can be its identification number (ID), or any other code given by the Company.",
    "textVehicle": "It corresponds to the equipment’s identification number which can be its identification number (ID), or any other given code by the Company.",
    "textSemiTrailer": "It corresponds to the ramp’s identification number which can be its identification number (ID), or any other given code by the Company.",
    "filterText": "Select the item or items to which the driver belongs to",
    "filterTextUser": "Select the item or items to which the user belongs to",
    "source": "Source",
    "dataSourceDescent": "Complete the equipment’s codes coming from external sources of information: SAP, ERP`s, among others.",
    "dataSourceSemiTrailerDescent": "Complete the ramp’s codes coming from external sources of information: SAP, ERP`s, among others.",
    "type": "Type",
    "feedBackDriverOk": "Vehicle created and associated to a source of information.",
    "feedBackDriverWarning": "Vehicle created with no association to sources of information.",
    "feedBackSemiTrailerOk": "Ramp created and associated to the source of information.",
    "feedBackSemiTrailerWarning": "Ramp created with no association to sources of information.",
    "teamCreateSuccess": "Association successfully completed.",
    "howCreatedExcel": "Would you like to download the excel template?",
    "browserIssue": "Your browser does not support the video tag.",
    "buttonDownload": "Download format template",
    "createVehicule": "Create an equipment",
    "dataSource": "Sources of information"
  },
  "modalDriver": {
    "buttonCreat": "Create a driver",
    "textLabel": "Please, select the list of driver’s files which you would like to upload to the platform; the file must have the defined format from the following file:",
    "buttonDelete": "Deactivate",
    "teamLabel": "Please, select the list of equipment’s files which you would like to upload to the platform; the file must have the defined format from the following file",
    "buttonActive": "Activate",
    "buttonCancel": "Cancel",
    "buttonEdit": "Update Driver",
    "buttonUpdate": "Update",
    "buttonUpdateFile": "Send file",
    "buttonDownload": "Download format template",
    "createDriverTitle": "Create driver",
    "deleteDriverTitle": "Deactivate driver",
    "activeDriverTitle": "Activate driver",
    "editDriverTitle": "Edit driver",
    "loading": "Loading !!!",
    "feedBackDriverOk": "Driver was created and associated to the source of information.",
    "feedBackDriverWarning": "Driver was created without any associated source of information.",
    "feedBackDriverOkEdit": "Driver updated and associated to the source of information.",
    "feedBackDriverWarningEdit": "Driver was updated without any associated source of information.",
    "feedBackDriverDeleteOne": "The driver",
    "feedBackDriverDeleteTwo": "was successfully disabled.",
    "feedBackDriverActiveOne": "The driver",
    "feedBackDriverActiveTwo": "was successfully activated.",
    "feedBackDriverUpdateOne": "the data was successfully uploaded.",
    "feedBackDriverUpdateTwo": "Error: solve the following problems and try to upload the file again.",
    "feedBackDriverUpdateThree": "Warning: The system allows to register data, but these could cause problems if not corrected.",
    "code": "Code",
    "name": "Name",
    "examine": "Examine",
    "row": "Row",
    "type": "Type",
    "detail": "Detail",
    "dataSource": "Codes in the information source",
    "downloadExcel": "Download Excel Template",
    "dataSourceDescent": "Complete the driver’s code which come from the external sources of information: SAP, ERP`s, among others.",
    "selectTags": "Select: The items which belong to the driver",
    "ErrorDelete": "Deactivation error",
    "isSureToDeleteOne": "Are you sure you want to deactivate this driver",
    "isSureToDeleteTwo": "from the platform ?",
    "isSureToDeleteThree": "* When this action is selected, the driver’s data will no longer be visible.",
    "isSureToDeleteFour": "Are you sure you want to activate this driver",
    "isSureToDeleteFive": "from the platform ?",
    "isSureToDeleteSix": "* When this action is selected, the driver’s data will be visible.",
    "howCreatedExcel": "Would you like to download the Excel template?",
    "browserIssue": "Your browser does not support the video tag.",
    "normalText": "Please, select the driver’s list files you would like to upload to the platform; the file must have the defined format from the following file:",
    "normalTextUser": "Please, select the user’s list file you would like to upload to the platform; the file must have the defined format from the following file:",
    "cognusMailConfig": {
      "title": "Digital voucher recipients",
      "placeholder": "Enter the emails",
      "description": "Corresponds to the group of emails to which the digital voucher will be sent each time this driver completes a PVT test",
      "helpText": "You can enter more than one email using a comma, the SPACE key or ENTER as a separator."
    },
    "howCreatedExcelAssociateUsers": "Download Excel template to associate users?",
    "normalTextUserAssociateUsers": "Please select the file to associate users with drivers that you want to upload to the platform. The file must have the format defined in the following document:",
    "messageErrorResultAssociateUsers": "The result of the user association process had some errors that you need to review in the downloaded file<br />(<b>total errors</b>: {totalErrors})",
    "downloadFileNameAssociateUsers": "associate-users",
    "downloadFileNameResultAssociateUsers": "user-association-result"
  },
  "filterDriver": {
    "show": "Display",
    "allDriver": "Drivers",
    "allVehicules": "Equipment",
    "allSemiTrailers": "Ramps",
    "associatedDriver": "Drivers associated to sources of information",
    "associatedVehicle": "Equipment associated to sources of information",
    "associatedSemiTrailer": "Ramps associated to sources of information",
    "associatedDriverOne": "Associated to a source of information",
    "pendingDriver": "Drivers with no source of information",
    "desactiveUser": "Deactivated users",
    "desactiveDriver": "Discharged drivers",
    "desactiveVehicles": "Discharged equipment",
    "desactiveSemiTrailers": "Discharged ramps",
    "activeDriver": "Enrolled drivers",
    "activeVehicles": "Enrolled equipment",
    "activeSemiTrailers": "Enrolled ramps",
    "PendingPartnership": "No association to the source of information"
  },
  "createDriver": {
    "create": "Create driver",
    "createOne": "Create drivers",
    "import": "Import Excel document",
    "importOne": "Import drivers",
    "download": "Download template",
    "associateDrivers": "Associate drivers",
    "drivers": "Drivers",
    "downloadFileName": "driver",
    "importUsers": "Import Users",
    "associateUsers": "Associate Users"
  },
  "createUser": {
    "importOne": "Import user",
    "downloadFileName": "users"
  },
  "createVehicules": {
    "creates": "Create equipment",
    "create": "Create an equipment",
    "import": "Import Excel document",
    "download": "Download template",
    "name": "Name",
    "code": "Code",
    "text": "It corresponds to the driver’s identification number which could be its identification number (ID) or any other given code by the company.",
    "filterText": "Select one or more items to which the equipment belongs to",
    "dataSource": "Codes in the sources of information",
    "dataSourceDescent": "Complete the equipment’s codes which come from external sources of information: SAP, ERP`s, among others.",
    "editDriverTitle": "Edit equipment",
    "feedBackOkEdit": "Equipment created and associated to the source of information",
    "feedBackWarningEdit": "Equipment created without any associated sources of information.",
    "downloadFileName": "equipment",
    "downloadFileNameHomologation": "homologationEquipment"
  },
  "editVehicule": {
    "editVehiculeTitle": "Edit equipment",
    "name": "Name",
    "code": "Code",
    "codeText": "It corresponds to the driver’s identification number which could be the driver’s identification number (ID) or any other code given by the company.",
    "filterText": "Select the carrier to which the driver belongs",
    "dataSource": "Sources of information",
    "dataSourceDescent": "You can create a driver without completing this section; However, it must be complete before it begins operating in Gauss control to make it visible in the platform.",
    "buttonEdit": "Update equipment",
    "feedBackDriverOkEdit": "The equipment has been updated and associated to the source of information.",
    "feedBackDriverWarningEdit": "The equipment has been updated without any sources of information."
  },
  "deleteVehicule": {
    "deleteVehiculeTitle": "Deactivate vehicle",
    "isSureToDeleteOne": "Are you sure you want to deactivate this equipment",
    "from": "from the platform ?",
    "isSureToDeleteThree": "* This action will from this moment make every equipment data visible.",
    "buttonDelete": "Deactivate",
    "buttonCancel": "Cancel",
    "feedBackDriverDeleteOne": "The equipment",
    "feedBackDriverDeleteTwo": "was successfully deactivated.",
    "feedBackDriverDeleteThree": "was successfully activated."
  },
  "activateVehicule": {
    "activateVehiculeTitle": "Activate equipment",
    "isSureToActivateOne": "Are you sure you want to activate this vehicle",
    "from": "in the platform ?",
    "isSureToActivateThree": "* This action will from this moment make every data about this vehicle visible.",
    "buttonActivate": "Activate",
    "buttonCancel": "Cancel",
    "feedBackVehiculeActivateOne": "The equipment",
    "feedBackVehiculeActivateTwo": "was successfully deactivated.",
    "feedBackVehiculeActivateThree": "was successfully activated."
  },
  "updateVehicule": {
    "import": "Import equipment",
    "examine": "Examine",
    "activateVehiculeTitle": "Activate vehicle",
    "buttonUpdateFile": "Send file",
    "row": "Row",
    "type": "Type",
    "feedBackVehiculeUpdateTwo": "Error: solve these problems and try uploading the file again.",
    "feedBackVehiculeUpdateThree": "Warning: The system allows to register data, but these could cause problems if not corrected.",
    "feedBackVehiculeUpdateOne": "The data was successfully charged",
    "isSureToActivateOne": "Are you sure you want to activate this vehicle",
    "detail": "Detail",
    "from": "in the platform ?",
    "isSureToActivateThree": "* This action will from this moment make every data about this vehicle visible.",
    "buttonActivate": "Update",
    "buttonCancel": "Cancel",
    "feedBackDriverUpdateOne": "The data was successfully updated.",
    "feedBackVehiculeActivateOne": "The equipment",
    "feedBackVehiculeActivateTwo": "was successfully deactivated.",
    "normalText": "Please, select the equipment list you want to upload to the platform; this file must have the same format as in the following file:"
  },
  "createSemiTrailers": {
    "creates": "Create ramps",
    "create": "Create ramp",
    "import": "Import Excel document",
    "download": "Download template",
    "name": "Name",
    "code": "Code",
    "text": "It corresponds to the ramp’s identification number which can be its number plate, or any other code given by the company.",
    "filterText": "Select the items which belong to the ramp",
    "dataSource": "Sources of information codes",
    "dataSourceDescent": "Complete the ramp’s codes coming from external sources of information: SAP, ERP`s, among others.",
    "editDriverTitle": "Edit ramp",
    "feedBackOkEdit": "Ramp was created and associated to the source of information.",
    "feedBackWarningEdit": "Ramp was created without any associated source of information."
  },
  "editSemiTrailer": {
    "editSemiTrailerTitle": "Edit ramp",
    "name": "Name",
    "code": "Code",
    "codeText": "It corresponds to the ramp’s identification number which can be its number plate, or any other code given by the Company.",
    "filterText": "Select the carrier for this ramp",
    "dataSource": "Sources of information",
    "dataSourceDescent": "You can create a driver without completing this section; However, this must be completed before you start operating in Gauss control for it to be visible in the platform.",
    "buttonEdit": "Update ramp",
    "feedBackDriverOkEdit": "Ramp was successfully updated and associated to the source of information.",
    "feedBackDriverWarningEdit": "Ramp was updated without any associated source of information."
  },
  "deleteSemiTrailer": {
    "deleteSemiTrailerTitle": "Deactivate ramp",
    "isSureToDeleteOne": "Are you sure you want to deactivate this ramp",
    "from": "from the platform ?",
    "isSureToDeleteThree": "* This action will from this moment make every ramp data not visible.",
    "buttonDelete": "Deactivate",
    "buttonCancel": "Cancel",
    "feedBackDriverDeleteOne": "The ramp",
    "feedBackDriverDeleteTwo": "was successfully deactivated.",
    "feedBackDriverDeleteThree": "was successfully activated."
  },
  "activateSemiTrailer": {
    "activateSemiTrailerTitle": "Activate ramp",
    "isSureToActivateOne": "Are you sure you want to activate this ramp",
    "from": "in the platform ?",
    "isSureToActivateThree": "* This action will from this moment make every ramp data be visible.",
    "buttonActivate": "Activate",
    "buttonCancel": "Cancel",
    "feedBackSemiTrailerActivateOne": "The ramp",
    "feedBackSemiTrailerActivateTwo": "was successfully deactivated.",
    "feedBackSemiTrailerActivateThree": "was successfully activated."
  },
  "updateSemiTrailer": {
    "import": "Import ramps",
    "examine": "Examine",
    "activateSemiTrailerTitle": "Activate ramp",
    "buttonUpdateFile": "Send file",
    "row": "Row",
    "type": "Type",
    "feedBackSemiTrailerUpdateTwo": "Error: solve these problems and try uploading the file again.",
    "feedBackSemiTrailerUpdateThree": "Warning: The system allows to register data, but these could cause problems if not corrected.",
    "feedBackSemiTrailerUpdateOne": "Data was successfully uploaded",
    "isSureToActivateOne": "Are you sure you want to activate this ramp",
    "detail": "Detail",
    "from": "in the platform ?",
    "isSureToActivateThree": "* This action will from this moment make every ramp data be visible.",
    "buttonActivate": "Update",
    "buttonCancel": "Cancel",
    "feedBackDriverUpdateOne": "Data was successfully uploaded",
    "feedBackSemiTrailerActivateOne": "The ramp",
    "feedBackSemiTrailerActivateTwo": "was deactivated successfully.",
    "normalText": "Please, select the ramp’s list you wish to upload to the platform, the file must have the same format as the following file:"
  },
  "roles": {
    "FatigueModuleFullAccess": "It allows to visualize the whole biocompatibility module report (summary, detail, driver).",
    "RoadWarningModuleFullAccess": "It allows to visualize the whole drowsiness events report (summary, detail, driver).",
    "AccountManagerReadOnly": "It allows to visualize the list of drivers, equipment, geo-zones configured in the platform.",
    "BehaviorModuleFullAccess": "It allows to visualize the whole behavioral module report (summary, detail and drivers).",
    "ManageFullAccess": "It allows to visualize and manage every deviation activated in the task manager.",
    "AccountManagerCrudAccess": "It allows to configure and visualize the platform (create, edit and deactivate) drivers, equipment, categories and geo-zones. It also allows to associate unknown equipment and drivers with their respective source of information codes.",
    "AccountManagerUserRoleAccess": "It allows you to view the platform and configure users (create, edit and deactivate).",
    "ManageReadAccess": "It allows to visualize all the deviations activated in the task manager.",
    "CFLModuleFullAccess": "It allows to visualize the whole cfl module report (summary, detail and driver).",
    "AssignmentFullAccess": "It allows to visualize and assign equipment to drivers.",
    "WaitingTimesFullAccess": "It allows to visualize the waiting time module report.",
    "UserProfileFullAccess": "It allows the user to visualize and modify its personal information.",
    "ApiInjection": "It allows to use the API integration services. Through this service it is possible to insert events and telemetry data in the Gauss control platform.",
    "FormFullAccess": "It allows to access and manage all forms through the mobile application and visualize the fleet and inspections report.",
    "FlowRequestsAdmin": "It allows to manage the vehicle’s flows to a determined route or others.",
    "FlowRequestsApplicant": "It allows to ask for the vehicle’s flows to a determined route or others.",
    "AlertnessInTimelineAccess": "It sets up the alert curve which shows the working shift as a timeline.",
    "FFDSleepModuleFullAccess": "It allows you to visualize the FFD sleepiness bracelets module reports.",
    "FFDPVTModuleFullAccess": "It allows you to visualize the Cognus pvt test module reports.",
    "ReclassificationInTasksManagementAccess": "It allows you to classify again every deviation in the task manager.",
    "DeanonymizationInTasksManagementAccess": "It allows you to evade anonymity within the deviations in the task manager.",
    "ManageCancelAccess": "It allows to cancel any deviation in the task manager.",
    "AnonymousFormReadAccess": "It allows you to visualize inspections with no assigned category",
    "ReportBIFullAccess": "It allows viewing reportability according to the permissions that the user has.",
    "MediaDmsAccess": "It allows you to view multimedia material associated with DMS events",
    "MediaDashcamAccess": "It allows you to view multimedia material associated with DASHCAM events",
    "MediaDownloadAccess": "It allows you to view and download multimedia material associated with events",
    "MediaListenAudioAccess": "It allows you to listen to audio of multimedia material associated with events",
    "AccountManagerCrudAccessTags": "It allows you to view the platform and add categories.",
    "AccountManagerCrudAccessGeozones": "It allows you to view the platform and configure geozones (create, edit and deactivate).",
    "AccountManagerCrudAccessVehicles": "It allows you to view the platform and configure vehicles and ramps (create, edit and deactivate). It also allows vehicles and ramps to be associated with their respective sources of information.",
    "AccountManagerCrudAccessDrivers": "It allows you to view the platform and configure drivers (create, edit and deactivate). It also allows drivers to be associated with their respective sources of information.",
    "FormFullDynamicListAccess": "It allows you to create and edit various lists of data used in the Forms module in the mobile application",
    "MediaCognusFaceVerificationAccess": "It allows you to view multimedia material associated with Cognus events",
    "MediaUnidentifiedDriverAccess": "It allows you to view multimedia material associated with unrecognized driver events",
    "SaasApiConsumer": "It allows you to use the API integration services. Through this service it is possible to insert events and telemetry data in the Gauss control platform."
  },
  "geozone": {
    "base": "Base",
    "principal": "Principal",
    "client": "Client",
    "onDuty": "Driving",
    "productive": "Productive",
    "stopped": "Stops",
    "withoutRest": "Waiting time",
    "waitingtime": "Waiting time",
    "workingplace": "Productive",
    "activate": "Activate geo-zone",
    "activateText": "Are you sure you want to deactivate the geo-zone",
    "howCreatedExcel": "Download the Excel template?",
    "isSureActivateText": "* This action will from this moment make this geo-zone data visible.",
    "trip": "Trip",
    "row": "Row",
    "type": "Type",
    "import": "Import geo-zone(s)",
    "importExcel": "Import Excel document",
    "deactivate": "Deactivate Geo-zone",
    "code": "Code",
    "detail": "Detail",
    "show": "Display",
    "featureTextOne": "Characteristics",
    "allGeozone": "Every geo-zone",
    "geozoneList": "Geo-zones list",
    "geozoneDeactivated": "Discharged geo-zones",
    "geozoneActive": "Enrolled geo-zones",
    "downloadExcel": "Download template",
    "downloadFileName": "geozone",
    "geozoneName": "Geo-zone’s name",
    "examine": "Examine",
    "isSureToDeleteOne": "Are you sure you want to deactivate this geo-zone",
    "isSureToDeleteTwo": "from the platform ?",
    "browserIssue": "Your browser does not support the video tag.",
    "isSureToDeleteThree": "* This action will from this moment make this geo-zone data visible.",
    "feedBackGeozoneUpdateThree": "Warning: The system allows to register data, but this could cause problems if not corrected.",
    "cancel": "Cancel",
    "mapMessageOne": "Oh snap!",
    "mapMessageTwo": "you can't draw that!",
    "feedBackGeozoneEditOne": "The geo-zone",
    "feedBackGeozoneEditTwo": "was successfully deactivated.",
    "feedBackGeozoneUpdateTwo": "Error: solve these problems and try uploading the file again.",
    "buttonDelete": "Deactivate",
    "feedBackGeozoneUpdateOne": "Data was successfully uploaded.",
    "updatText": "Please, select the geo-zone’s list file you want to upload to the platform, the file must have the same format as the following file:",
    "modalCreate": {
      "create": "Create Geo-zone",
      "import": "Import geo-zone(s)",
      "name": "Name",
      "features": "Geo-zone’s characteristics",
      "featureText": "Select the characteristic or characteristics from this geo-zone",
      "baseText": {
        "base": "This characteristic will determine the color shown in the geo-zone in a shift.",
        "principal": "This characteristic will determine the color shown in the geo-zone in a shift.",
        "client": "This characteristic will determine the color shown in the geo-zone in a shift.",
        "onDuty": "This characteristic will determine the color shown in the geo-zone in a shift.",
        "stopped": "This characteristic will determine the color shown in the geo-zone in a shift.",
        "withoutRest": "This characteristic will determine if the driver’s stoppage in the zone is considered as a part of its working hours (not its resting period). This affects the fatigue indicators",
        "productive": "This characteristic determines if the waiting period of the vehicles are shown in the waiting time module.",
        "trip": "This characteristic determines if the geo-zone is considered for the creation or the ending of the trips in the behavioral module.",
        "workingplace": "This characteristic will determine if the driver’s stoppage is considered as a part of its working hours (not its resting period). This affects the fatigue indicators.",
        "waitingtime": "This characteristic will determine if the vehicle time is shown in the waiting time’s module."
      },
      "code": "Code",
      "codeText": "It corresponds to the geo-zone identification code.",
      "createSucces": "Geo-zone was successfully created.",
      "_codeText": "It corresponds to the geo-zone identification code."
    },
    "modalEdit": {
      "edit": "Edit Geo-zone",
      "editText": "Edit",
      "deactivateText": "Deactivate",
      "activateText": "Activate",
      "features": "Geo-zone characteristics",
      "featureText": "Select the characteristic or characteristics of this geo-zone",
      "featureTextOne": "Characteristic",
      "name": "Name",
      "baseText": {
        "base": "This characteristic determines the color in the geo-zone in the working day visualization.",
        "principal": "This characteristic determines the color shown in the shift visualization regarding its stay in the geo-zone.",
        "client": "This characteristic determines the color shown in the shift visualization regarding its stay in the geo-zone.",
        "onDuty": "This characteristic determines the color shown in the shift visualization regarding its stay in the geo-zone.",
        "stopped": "This characteristic determines the color shown in the shift visualization regarding its stay in the geo-zone.",
        "withoutRest": "This characteristic will determine if the driver’s stoppage in the zone is considered as a part of its working hours (not its resting period). This affects the fatigue indicators",
        "productive": "This characteristic will determine if the vehicle’s time is shown in the waiting time’s module.",
        "trip": "This characteristic determines if the geo-zone will be considered for trips creation and finalization in the behavioral module. If it does not have this characteristic then all trips to or from this geo-zone will not be charged.",
        "workingplace": "This characteristic will determine if the driver’s stoppage in the zone is considered as a part of its working hours (not its resting period). This affects the fatigue indicators.",
        "waitingtime": "This characteristic will determine if the vehicle’s time is shown in the waiting time’s module."
      },
      "code": "Code",
      "codeText": "It corresponds to the identification number of the geo-zone.",
      "buttonEdit": "Update Geo-zone",
      "editSucces": "Geo-zone was successfully updated.",
      "modelActivate": {
        "isSureToActivateOne": "* This action will from this moment make this geo-zone data be visible.",
        "isSureToActivateTwo": "in the platform ?",
        "buttonActivate": "Activate",
        "feedBackGeozoneActivateTwo": "was successfully activated."
      }
    }
  },
  "accountUser": {
    "alertnessintimelineaccess": "Set up a curve alert in the shift timelines",
    "cflmodulefullaccess": "Look at CFL Module",
    "ffdsleepmodulefullaccess": "Look at Fitness for duty sleepiness bracelets Module",
    "ffdpvtmodulefullaccess": "Look at Cognus test pvt Module",
    "accountmanagercrudaccess": "Configure entities",
    "accountmanagerreadonly": "Visualize platform configuration",
    "accountmanageruserroleaccess": "Set up user accounts",
    "apiinjection": "Data supplier",
    "assignmentfullaccess": "Assign driver to an equipment",
    "behaviormodulefullaccess": "Look at behavioral Module",
    "fatiguemodulefullaccess": "Look at biocompatibility Module",
    "anonymousformreadaccess": "Look at anonymous inspections",
    "formfullaccess": "Manage forms",
    "managefullaccess": "Handle deviations",
    "managereadaccess": "Look at deviations",
    "reclassificationintasksmanagementaccess": "Reclassify deviations",
    "deanonymizationintasksmanagementaccess": "Nullify deviation",
    "managecancelaccess": "Nullify deviations",
    "roadwarningmodulefullaccess": "Look at Drowsiness events Module",
    "waitingtimesfullaccess": "Look at waiting time’s Module",
    "userprofilefullaccess": "Look user’s profile",
    "userAccount": "User’s list",
    "showUsers": "Show: Every user",
    "allUsers": "Every user",
    "deactivateUsers": "Discharged users",
    "activateUsers": "Unrolled users",
    "userRole": "Permits: All",
    "userRoleTitle": "Permits",
    "createUser": "Create user",
    "userSuccess": "User was successfully created.",
    "name": "Name",
    "email": "E-mail (username)",
    "password": "Password",
    "passwordError": "Passwords are not the same",
    "repeatPassword": "Repeat password",
    "currentPassword": "Current password",
    "newPassword": "New password",
    "isAdmin": "Administrator",
    "rol": "Permits",
    "labelSelection": "Select one or more permits for this user",
    "rolLabel": "It corresponds to the group of permits and functions in the platform assigned to the user.",
    "actions": "Actions",
    "endOfTime": "No more data",
    "editUser": "Edit user",
    "ActualizarUser": "Update user",
    "updatePassword": "Update password",
    "isUpdatePassword": "Password was updated",
    "userActivated": "User was updated",
    "deactivateUser": "Deactivate user",
    "activateUser": "Activate user",
    "activateUserOne": "Activate",
    "deactivateUserLabel": "Are you sure you want to deactivate this user",
    "deactivateUserLabelOne": "from the platform ?",
    "deactivateUserLabelTwo": "* This action will from this moment make the user’s data not visible",
    "cancel": "Cancel",
    "userTextOne": "The user",
    "userTextTwo": "has been deactivated. From this moment on it will not be allowed to access to the platform.",
    "userTextThree": "has been activated. From this moment on it will be allowed to access the platform.",
    "isSureToActivateOne": "Are you sure you want to activate this user",
    "isSureToActivateTwo": "in the platform ?",
    "isSureToActivateThree": "* This action will from this moment make the user’s data visible.",
    "editPassWord": "Reestablish password",
    "accountSettings": {
      "title": "Client configuration",
      "save": "Save"
    },
    "flowrequestsadmin": "Look at flow module - Administrator",
    "flowrequestsapplicant": "Look at flow module - Applicant",
    "reportbifullaccess": "Look at reports",
    "mediadmsaccess": "View DMS multimedia material in the cabin",
    "mediadashcamaccess": "View DASHCAM multimedia material",
    "mediadownloadaccess": "Download media",
    "medialistenaudioaccess": "Listen to audio from media",
    "accountmanagercrudaccesstags": "Configuration categories",
    "accountmanagercrudaccessgeozones": "Geozones configuration",
    "accountmanagercrudaccessvehicles": "Configuration vehicles and ramps",
    "accountmanagercrudaccessdrivers": "Configuration drivers",
    "formfulldynamiclistaccess": "Configuration of dynamic lists in the form",
    "mediacognusfaceverificationaccess": "View Cognus enrollment material",
    "mediaunidentifieddriveraccess": "View failed facial recognition footage",
    "passwordChecklist": {
      "minLength": "The password is more than 8 characters long.",
      "specialChar": "The password contains special characters (!@#$%^&*).",
      "number": "The password contains a number (0-9).",
      "capital": "The password contains an uppercase letter (A-Z).",
      "lowercase": "The password contains a lowercase letter (a-z).",
      "match": "The passwords match."
    },
    "massiveActions": "Massive Actions",
    "saasapiconsumer": "SaaS API Consumer"
  },
  "accountAssigment": {
    "withoutConnection": "Vehicles with no connection",
    "anonymousDriver": "(Anonymous driver)",
    "team": "Equipment",
    "hour": "Time",
    "driver": "Driver",
    "vehicleCode": "Vehicle code",
    "categorie": "Categories",
    "assignDate": "Allocation date",
    "assignTime": "Allocated time",
    "detail": "Detail",
    "headTitle": "Allocation list",
    "paragraphTitle": "Through this view you may check the allocated drivers to a vehicle to date. If a driver is not shown it is because it is not allocated to any equipment."
  },
  "workingShiftGroup": {
    "name": "Name",
    "workingShiftGroupType": "Shift type",
    "workingShiftStructureDays": "Shift structure days",
    "workingShiftStartDate": "Regime starting date",
    "workingShiftGroupTypeHelp": "It corresponds to the shift structure type being dynamic when it does not follow a definite pattern which repeats in time, example: 5x2, 10x10, among others.",
    "workingShiftStructureDaysHelp": "It corresponds to the total amount of days which conforms the shift’s structure (working days and resting days).",
    "workingShiftStartDateHelp": "It corresponds to the date in which the working group will begin with their work.",
    "dynamicWorkingShift": "Dynamic shift",
    "fixedStructureWorkingShift": "Definite structure for this shift",
    "doesNotApply": "Does not apply",
    "deactivateWorkingShiftGroup": "Delete this shift group",
    "deactivateWorkingShiftGroupLabel": "Are you sure you want to delete this shift group",
    "deactivateWorkingShiftGroupLabelOne": "?",
    "deactivateWorkingShiftGroupLabelTwo": "* If this group has had allocated people all the historical information will be lost.",
    "cancel": "Cancelar",
    "workingShiftGroupTextOne": "The shift group",
    "workingShiftGroupTextTwo": "has been deleted.",
    "deleteText": "Delete",
    "editText": "Edit",
    "cantDeleteHelp1": "You cannot delete this shift group.",
    "cantDeleteHelp2": "There are user allocated to this shift group.",
    "editModalTitle": "Edit shift group",
    "buttonEdit": "Update shift group",
    "feedBackOkEdit": "Shift group updated.",
    "createModalTitle": "Create shift group",
    "buttonCreate": "Create shift group",
    "feedBackOkCreate": "Shift group was created.",
    "form": {
      "name": "Group name",
      "namePlaceholder": "Write down the name of this shift group",
      "type": "Type of shift",
      "typeInfo": "Select the dynamic shift checkbox if the structure does not follow a definite pattern.",
      "typeHelp": "This shift does not follow a definite structure pattern.",
      "workingShiftStructureDays": "Shift structure days",
      "workingShiftStructureDaysPlaceholder": "Write down the shift structure number of days (including resting periods)",
      "workingShiftStructureDaysHelp": "It correspond to the total number of days which conform the shift structure (working days and resting days).",
      "planification": "Shift group schedule planning",
      "planificationHelp": "It corresponds to the scheduling of the starting and ending period for each one of the working days in the shift as well as the resting days plan.",
      "planificationHelp2": "This plan will repeat as a cycle from the starting date registered on.",
      "planificationTable": {
        "days": "DAY",
        "workingDayType": "Working day type",
        "workType": "Job",
        "restType": "Resting period",
        "startTime": "Starting point",
        "endTime": "Ending point",
        "hourPlaceholder": "Set time"
      },
      "workingShiftStartDate": "Regime starting date",
      "workingShiftStartDatePlaceholder": "Introduce the starting date for this shift group",
      "workingShiftStartDateHelp": "It corresponds to the date in which a specific groups shift will begin their work.",
      "allowedTimeFFD": "Send Cognus report before the beginning of the shift (minutes)",
      "allowedTimeFFDPlaceholder": "Introduce the allowed time",
      "allowedTimeFFDHelp": "Cognus PVT report must be sent in advance to the start of the shift.",
      "allowedTimeFFDHelp2": "Example, if the required time is 20 minutes and the shift schedule begins at 8:00 a.m. then the report must be sent at 7:40 a.m..",
      "maxLateTimeFFD": "Maximum delay allowed in Cognus evaluation (minutes)",
      "maxLateTimeFFDPlaceholder": "Introduce the allowed time",
      "maxLateTimeFFDHelp": "Maximum allowed time for the system to wait until the evaluation of the Cognus of a person posterior to the beginning of a shift.",
      "maxLateTimeFFDHelp2": "Example, if you wish the individual who will complete the Cognus test 31 or additional minutes after the beginning of the shift to be registered as a “realization incident” then a 30-minute variable should be considered.",
      "maxAdvanceTimeFFD": "Maximum allowed time for an anticipated Cognus evaluation (minutes)",
      "maxAdvanceTimeFFDPlaceholder": "Introduce the allowed time",
      "maxAdvanceTimeFFDHelp": "Maximum allowed time which the system will consider receiving the Cognus evaluation information before the scheduled time for the beginning of a shift.",
      "maxAdvanceTimeFFDHelp2": "Example, if you wish the people to have the opportunity to complete the Cognus evaluation as far as 2 hours before the beginning of their shift, then the parameter must be configured with 120 minutes.",
      "mailRecipients": "Cognus notification e-mails",
      "mailRecipientsPlaceholder": "Introduce the e-mails separated by a comma",
      "mailRecipientsHelp": "It corresponds to the list of e-mails to which the system will notify the condition of rejection of a Cognus evaluation and competition incidents in a PVT test."
    }
  },
  "accountTag": {
    "header": {
      "title": "Categories"
    },
    "card": {
      "list": {
        "title": "Categories",
        "create": "Create category",
        "name": "Name",
        "click": "Click here to add a new item",
        "action": "Actions",
        "label_alert": "The name of this category must at least contain one letter",
        "legend_text": "There are no created categories",
        "placeholder": "Add a new category ...",
        "label": "Add a new category by pressing Enter or cancel it by pressing Esc"
      },
      "item": {
        "title": "Category items",
        "create": "Add an item",
        "name": "Name",
        "action": "Actions",
        "legend_text": "There are no created items",
        "label": "Add a new item by pressing Enter or cancel it by pressing Esc",
        "label_alert": "The name of this item can only contain letters and/or numbers, at least one character and must not begin with a number.",
        "placeholder": "Add an item to this category",
        "btn_cancel": "Cancel",
        "btn_save": "Save"
      },
      "input": {
        "addItemLabel": "add an item",
        "labelAlert": "The name of this category must at least contain one letter"
      },
      "toastrLabel": {
        "info": "Information",
        "error": "Error",
        "confirm": "Yes",
        "cancel": "No",
        "delete": "Delete",
        "create": "Create",
        "questionPart1": "Are you sure you want to save the following changes made in this category",
        "questionPart1Cancel": "Are you sure you want to cancel all these changes? If you cancel all these modifications will be lost.",
        "caution": "This action will make the deleted historical trajectory about the items be deleted from the platform.",
        "allTagsCreated": "Every change made were successfully saved.",
        "someTagsCreated": "Some of the changes were not successfully saved.",
        "someTagsCreatedDetail": "Unsaved changes:",
        "noTagsCreated": "Changes could not be saved",
        "tagsCreationError": "The changes were not saved, try again."
      }
    }
  },
  "accountList": {
    "header": {
      "title": "Digital Checklists"
    },
    "card": {
      "list": {
        "title": "Lists",
        "create": "Create lists",
        "name": "Name",
        "click": "Click here to add a list",
        "action": "Actions",
        "label_alert": "The name of this list can only contain letters and/or numbers and at least one character.",
        "legend_text": "There are no created lists",
        "placeholder": "Add a list ...",
        "label": "Add another list by pressing Enter or cancel it by pressing Esc"
      },
      "item": {
        "title": "Items from the list",
        "create": "Add item",
        "name": "Name",
        "action": "Actions",
        "legend_text": "There are no created items",
        "label": "Add another item by pressing Enter or cancel it by pressing Esc",
        "label_alert": "The name of this item can only contain letters and/or numbers and at least one character.",
        "placeholder": "Add a item to the list",
        "btn_cancel": "Cancel",
        "btn_cancel_help": "To edit the lists again you must save or cancel.",
        "btn_save": "Save",
        "editItem": "Edit item"
      },
      "input": {
        "addItemLabel": "add item",
        "labelAlert": "The name of this list must contain at least one letter"
      },
      "toastrLabel": {
        "info": "Information",
        "error": "Error",
        "confirm": "Yes",
        "cancel": "No",
        "delete": "Delete",
        "create": "Create",
        "update": "Edit",
        "questionPart1": "Are you sure you want to save the following changes in the list",
        "questionPart1Cancel": "Are you sure you want to cancel the changes? You will lose every modification made.",
        "questionPart1DeleteList": "Are you sure you want to delete this list",
        "cautionListDelete": "Deleting a list that is being used by a digital checklist may cause an unexpected performance.",
        "allItemsCreated": "Every change was successfully saved.",
        "someItemsCreated": "Some of the changes were not successfully saved.",
        "someItemsCreatedDetail": "Unsaved changes:",
        "noItemsCreated": "Changes could not be saved.",
        "itemsCreationError": "The changes were not saved, try again.",
        "listDeleted": "The list was successfully deleted.",
        "listDeletedError": "The list could not be deleted.",
        "listCreated": "The list has been successfully created.",
        "listCreatedError": "The list could not be created."
      }
    }
  },
  "accountExtendedProperty": {
    "title": "Additional attributes",
    "table": {
      "name": "Name",
      "dataType": "Type of information",
      "owner": "Owner",
      "actions": "Actions",
      "date": "Dates",
      "text": "Text",
      "person": "Person",
      "vehicle": "Equipment",
      "semitrailer": "Ramp"
    },
    "buttons": {
      "createExtendedProperty": "Create an attribute"
    },
    "modal": {
      "buttonCreate": "Create an attribute",
      "buttonDelete": "Delete",
      "editText": "Edit",
      "buttonCancel": "Cancel",
      "buttonEdit": "Update attribute",
      "buttonUpdate": "Update",
      "createTitle": "Create attribute",
      "deleteTitle": "Delete attribute",
      "editTitle": "Edit attribute",
      "loading": "Loading !!!",
      "feedBackOk": "Attribute was created.",
      "feedBackOkEdit": "Attribute was updated.",
      "feedBackDeleteOne": "The attribute",
      "feedBackDeleteTwo": "was successfully deleted.",
      "name": "Name",
      "errorDelete": "An error occurred when deleting",
      "isSureToDeleteOne": "Are you sure you want to delete this attribute",
      "isSureToDeleteTwo": "from the platform ?",
      "isSureToDeleteThree": "This action will from this moment make the owners of this attribute and the forms which it affects, lose the information.",
      "buttonOK": "Ok"
    },
    "filter": {
      "show": "Display",
      "allProperties": "All the attributes",
      "person": "Person attributes",
      "vehicle": "Equipment’s attributes",
      "semiTrailer": "Ramp’s attributes"
    },
    "help": {
      "title": "It represents the additional attributes which can be configured for a person or an equipment, for example: driving license date, equipment’s ramp, achieved courses, among others. These will be visible and must be completed in the question inspection as well as in the creation of personnel and equipment.",
      "dataType": "It represents if the attribute corresponds to a text or a specific date. For example, expiring date of a driving license or ramp from a particular equipment.",
      "owner": "It corresponds to the entity (equipment, ramps or personnel) to which this attribute affects.",
      "formName": "Write the name for this attribute",
      "formDataType": "Select the type of information of this attribute",
      "formOwner": "Select to whom this attribute it affects"
    }
  },
  "others": {
    "categories": "Categories",
    "selectOneItem": "Select at least one item",
    "loading": "Loading",
    "incorrectFormat": "The file format is incorrect",
    "noData": "There is no data",
    "downloadFormat": "Download the format template",
    "save": "Save",
    "categoriesHelp": "Configure the categories for the selected permissions",
    "selectOneItemCategories": "Categories for all permissions: Select and item for each category.",
    "selectMultipleItemsCategories": "Permission categories for the task manager module: Select one or more items for each visible category in the task manager module.",
    "changeStateMultipleSelectQuestion": "Are you sure you want to add other permissions besides the ones from the task manager to this user?",
    "changeStateMultipleSelectWarning": "When carrying out this action, all assigned categories to this user will be deleted and must be completed again.",
    "categoryAccessDenied": "All items from this category are now disabled because the permissions do not happen to meet the ones the user actually has.",
    "selectOnlyOneItem": "Select only one item per category",
    "disclaimerCategories": "The changes made in the Categories will be reflected on the platform on the day",
    "formWithErrors": "Form with errors",
    "reviewInformationBeforeSending": "Review the information on the form before submitting it",
    "at": "at",
    "shouldSelectOnlyOneItem": "You must select only one item",
    "has": "has",
    "disclaimerAssociateUsers": "<b>IMPORTANT</b>: Once the process is finished, <b>YOU MUST</b> save the downloaded Excel file to review the summary of the process."
  },
  "date": {
    "format": "MM-DD-YY",
    "formatShort": "MM-DD",
    "graphFormatTooltip": "%m-%d-%y",
    "graphFormatXAxis": "%m-%d"
  }
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/english/account/account.js